<template>
  <max-z-index :show="currentValue" :relative="relative">
    <div @touchmove="onTouchMove" style="touch-action: none;">
      <transition :name="maskTransition">
        <masks
          :mshow="currentValue"
          :mopacity = "mOpacity"
          @onHide="maskHide">
        </masks>
      </transition>
      <transition :name="dialogTransition" >
        <div v-show="currentValue" style="z-index:2002;" v-bind:class="dialogStyle" :style="{whight, top: '0px'}">
          <slot></slot>
        </div>
      </transition>
    </div>
  </max-z-index>
</template>
<script>
import Masks from '@/components/mask/index.vue'
import MaxZIndex from '@/components/max-z-index/index.vue'
const handler = (e) => {
  e.preventDefault()
  // e.stopPropagation()
}
let passiveSupported = false;

try {
  var options = Object.defineProperty({}, "passive", {
    get: function() {
      passiveSupported = true;
    }
  });

} catch(err) {}

export default {
  components:{
    Masks,
    MaxZIndex
  },
  props: {
    mshow: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'beast-mask'
    },
    // maskStyle: {
    //   type: String,
    //   default: 'beast__mask'
    // },
    dialogTransition: {
      type: String,
      default: 'beast-dialog-login'
    },
    dialogStyle: {
      type: String,
      default: 'beast__dialog-m'
    },
    mask: {
      type: Boolean,
      default: true
    },
    maskTouchHide: {
      type: Boolean,
      default: false
    },
    scroll: {
      type: Boolean,
      default: true
    },
    maskOpacity: {
      // type: Number,
      default: 0.4
    }
  },

  created () {
    if (typeof this.mshow !== 'undefined') {
      this.currentValue = this.mshow
    }
  },
  data () {
    return {
      currentValue: false,
      top: 0,
      relative: false
    }
  },

  computed:{
    mOpacity: function(){
      return this.mask ? parseFloat(this.maskOpacity) : 0
    },
    whight: function(){
      return `height:${document.documentElement.clientHeight}px;`
    }
  },

  watch: {
    mshow (val) {
      if(val){
        console.log(this.$el)
        const _top = document.documentElement.scrollTop || document.body.scrollTop
        // this.top = _top + document.documentElement.clientHeight
        this.top = _top
        this.$el.addEventListener('touchmove', handler, false)
      }else{
        this.$el.removeEventListener('touchmove', handler, false)
      }
      this.currentValue = val
    },
    currentValue (val) {
      val || this.$emit('mask-hide')
    }
  },
  methods: {
    onTouchMove: function (event) {
      !this.scroll && event.preventDefault()
    },
    maskHide: function (){
      this.mask && this.maskTouchHide && (this.currentValue = false)
    }
  }
}
</script>
<style lang="stylus">
  @import '../../common/styl/global'

  .beast-mask-enter, .beast-mask-leave-active
      opacity 0

  .beast-mask-leave-active, .beast-mask-enter-active
    transition opacity 300ms

  .beast-dialog-login-enter-active,.beast-dialog-login-leave-active
    opacity 1
    transition-duration 300ms
    // transform translate(-50%, -50%) scale(1)!important
    transition-property  opacity

  .beast-dialog-login-enter, .beast-dialog-login-leave-active
    opacity 0
    // transform translate(-50%, -50%) scale(1.185)!important
  .beast__mask
    position fixed
    top 0
    left 0
    right 0
    bottom 0
    z-index 1000
    background rgba(0, 0, 0, 0.4)
  .beast__dialog-m
    position absolute
    width 100%
    height 100%
    // top 50%
    left 0
    // transform translate(-50%, -50%)

</style>



// WEBPACK FOOTER //
// login-dialog.vue?10191f46